export function aModifyName({ commit }, Name) {
    console.log('action-a');
    return commit('modifyA', Name);
}

export function bModifyName({ commit }, Name) {
    console.log('action-b');

    return commit('modifyB', Name);
}